<template>
  <div class="app-contanier">
    <div class="back" @click="back">
      <van-icon name="arrow-left" size="0.5rem" />
      <span>返回</span>
    </div>

    <div class="content">
      <div class="price-row">
        <span>支付：</span>
        <div class="price"><em>¥</em>{{ totalPrice }}</div>
      </div>

      <div class="isPrint">
        <van-checkbox v-model="isPrint" icon-size="34px" checked-color="#ee0a24">是否打印小票</van-checkbox>
      </div>



      <!-- <div class="sub-title">请在刷脸机刷脸/刷饭卡支付</div> -->

      <div class="pop-pos">
        <div class="eg-bg">
          <van-image width="7.38rem" height="7.98rem" fit="contain" :src="require('@/assets/bg03.png')" />
        </div>
      </div>
      <div class="other" @click="onOther">选择其他支付方式</div>

    </div>
    <div class="time">（{{ sendmsg }}）</div>

    <van-popup v-model="popupShow0" closeable @click-close-icon="onChangPos" round position="center"
      :close-on-click-overlay="false">
      <div class="pop">
        <div class="tit">请在下方区域扫描二维码</div>
        <div class="eg-bg">
          <van-image width="7.38rem" height="7.98rem" fit="contain" :src="require('@/assets/bg01.png')" />
          <div class="eg">
            <van-image width="2.8rem" height="2.8rem" fit="contain" :src="require('@/assets/code.png')" />
          </div>
          <div class="line"></div>
        </div>
        <div class="pay-list">
          <div @click="onPay(item)" :class="['pay-item', item.disabled && 'disabled']"
            :style="{ 'background-color': item.bg }" v-for="(item, idx) in payList" :key="idx">
            <van-image width="0.88rem" height="0.88rem" fit="cover" :src="item.icon" />
            <span>{{ item.text }}</span>
          </div>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import { getData } from '@/api/home';
import Speech from 'speak-tts'
import { Toast } from 'vant';
import serialPortManager from '@/utils/serial';

let music = new Audio();

export default {
  data() {
    return {
      sendmsg: '',
      totalPrice: 0.00,
      payList: [
        // {
        //   icon: require('@/assets/icon-card.png'),
        //   type: 1,
        //   text: "刷饭卡",
        //   bg: '#E4F2FF',
        //   mode: '饭卡',
        //   disabled: false
        // },
        {
          icon: require('@/assets/icon-scan.png'),
          type: 2,
          text: "支付码支付",
          bg: '#FFF1CF',
          mode: '会员码',
          disabled: false
        }, {
          icon: require('@/assets/icon-wx.png'),
          type: 3,
          text: "微信支付",
          bg: '#E0FFE0',
          mode: '微信',
          disabled: false
        }, {
          icon: require('@/assets/icon-alipay.png'),
          type: 4,
          text: "支付宝支付",
          bg: '#E0EFFF',
          mode: '支付宝',
          disabled: false
        }],
      flag: true,
      popupShow0: false,
      orderNumber: '',
      isPrint: false,
      successAutoplay: false,
      failAutoplay: false,
      speech: null,
      carnum: 0,
      payType: 1,

      //链接刷脸机 串口相关
      port: null,
      reader: null,
      writer: null,
      isConnected: false,
      portInfo: '',
      packetSequence: 0,
      lastCommand: null,
      showBrowserWarning: false,
      //交易信息
      transactionStatusMessage: '',
    }
  },
  created() {
    let totalPrice = this.$route.params.totalPrice;
    let orderNumber = this.$route.params.orderNumber;
    let carnum = this.$route.params.carnum;
    if (totalPrice) {
      this.totalPrice = totalPrice;
      this.orderNumber = orderNumber;
      this.carnum = carnum
    }
    this.timeDown();
    let that = this;
    let str = '';
    document.onkeydown = function (e) {

      var key = window.event.key;
      if (that.flag && that.payType !== 1) { // 支付码支付 不监听键盘事件
        //console.log('键盘监听')
        if (key === 'Enter') {
          that.pay(str, false)
          str = ''
        } else if (key.length == 1) {
          str = str + key;
        }
      }
    }
    // jm店需要展示勾选打印小票
    this.isPrint = this.$storage.get('store').storeId === 6;
    this.initSerialPortHandler()
  },
  mounted() {
    this.speechInit()
  },
  // destroyed() {
  //   //取消键盘监听事件
  //   document.onkeydown = null
  // },

  methods: {

    // 添加数据监听
    dataHandler(hexData) {
        serialPortManager.removeDataListener(this.dataHandler);
        this.pay(hexData.join(''), true)
        serialPortManager.disconnect();
    },
    initSerialPortHandler() {
      // 连接设备
      serialPortManager.connect()
        .then(() => {
          serialPortManager.sendCommand(this.orderNumber)
          serialPortManager.addDataListener(this.dataHandler);
        })
        .catch(err => console.error('连接失败', err));
    },

    speechInit() {
      this.speech = new Speech()
      this.speech.setLanguage("zh-CN")
      this.speech.init().then(() => { })
      this.speckFn()
    },
    speckFn() {
      const text = `共计${this.carnum}件商品，需支付${this.totalPrice}元`
      this.speech.speak({ text }).then(() => {
        console.log("读取成功");
      });
    },
    goSettle() {
      this.$router.push({ name: "settle" })
    },
    timeDown() {
      let timer = 120;
      this.sendmsg = timer;
      this.timeFun = setInterval(() => {
        --timer;
        this.sendmsg = timer;
        if (timer == 0) {
          this.back();
        }
      }, 1000);
    },
    back() {
      clearInterval(this.timeFun);
      serialPortManager.removeDataListener(this.dataHandler);
      serialPortManager.cancelTransaction();
      serialPortManager.disconnect();
      this.$router.go(-1);
    },
    // onPay(item) {
    //   this.payMode = item.mode;
    //   this[`popupShow${item.type}`] = true;
    // },
    onChangPos() {
      this.payType = 1;
      this.popupShow0 = false;
      this.initSerialPortHandler()
      Toast('已切换至刷脸机支付')
    },
    onOther() {
      console.log('切换其他支付方式')
      serialPortManager.cancelTransaction()
      serialPortManager.disconnect();
      this.payType = 2;
      this.popupShow0 = true;
    },
    sussessMp3() {
      music.src = require('@/assets/pay_success.mp3')
      music.play();
    },
    FailMp3() {
      music.src = require('@/assets/pay_fail.mp3')
      music.play();
    },
    isCorrect(payCode) {
      // 截取字符串的第6到38位（不包含38）进行比较
      return this.orderNumber.substring(6, 38) === payCode.substring(6, 38);
    },
    pay(str, serial) {
      if (str && this.flag) {
        this.flag = false;
        getData('pay', {
          payCode: str,
          orderNumber: this.orderNumber
        }).then(res => {
          // 播放成功音频
          this.sussessMp3();
          const thirdLen = Math.floor( this.orderNumber.length / 3);
          const lastThird = this.orderNumber.slice(-thirdLen);
          this.$router.push({
            name: "success",
            params: { 'totalPrice': this.totalPrice, 'orderNumber': lastThird, 'isPrint': this.isPrint ? '1' : '' }
          })
          this.popupShow0 = false;
          clearInterval(this.timeFun);
        }).catch(error => {
          // 播放失败音频
          this.FailMp3();
        }).finally(() => {
          this.flag = true;
        })
      }
    },

  }
}
</script>

<style lang="less" scoped>
.app-contanier {}

.back {
  margin: 24px 0 14px 24px;
  display: flex;
  align-items: center;
}

.content {
  padding: 20px 10px 15px;
  width: 90%;
  margin: auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .2);
  border-radius: 2px;
  box-sizing: border-box;
}

.price-row,
.sub-title {
  text-align: center;
}

.price-row {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;

  .price {
    color: #DB0B11;

    em {
      font-size: 20px;
      font-style: normal;
    }
  }
}

.isPrint {
  margin: 16px auto 0;

  .van-checkbox {
    justify-content: center;
  }

}

.sub-title {
  padding: 15px 0;
  color: #333;
  font-size: 16px;
}



.time {
  margin-top: 15px;
  text-align: center;
  font-size: 18px;
}

.other {
  text-align: center;
  font-size: 15px;
  color: #409eff;
}

.pay-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr); // 创建两列
  gap: 10px; // 列之间的间距
}

.pay-item {
  padding: 10px;
  font-size: 14px;
  border-radius: 8px;
  display: flex;
  flex-direction: column; // 垂直排列子元素
  align-items: center; // 水平居中
  justify-content: center; // 垂直居中
}

.pay-item.disabled {
  opacity: .6;
}

.pop,
.pop-pos {
  padding-top: 25px;
  width: 315px;
  height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .tit {
    font-size: 18px;
  }

  .eg-bg {
    // margin-top: 25px;
    // width: 100%;
    position: relative;
    border-radius: 10px;
    overflow: hidden; // 确保子元素不会超出父元素边界

    .eg {
      position: absolute;
      bottom: 0px;
      right: 32px;

      animation: shaking 1.25s linear infinite;
      -webkit-animation: shaking 1.25s linear infinite;
    }


    .line {
      position: absolute;
      width: 111px;
      height: 3px;
      right: 30px;
      bottom: 75px;
      background-color: #FF0000;
    }
  }
}

.pop-pos {
  height: 330px;
}

@keyframes shaking {

  20% {
    bottom: 20px;
  }

  40% {
    bottom: 30px;
  }

  60% {
    bottom: 40px;
  }

  80% {
    bottom: 20px;
  }

  100% {
    bottom: 0;
  }
}
</style>
